import MuiFormHelperText from '@mui/material/FormHelperText';
import type { ComponentPropsWithoutRef, ComponentRef } from 'react';
import { forwardRef } from 'react';

type FormHelperTextProps = ComponentPropsWithoutRef<typeof MuiFormHelperText>;
type FormHelperTextRef = ComponentRef<typeof MuiFormHelperText>;

const FormHelperText = forwardRef<FormHelperTextRef, FormHelperTextProps>(
  (props, ref) => {
    return <MuiFormHelperText ref={ref} {...props} />;
  },
);
FormHelperText.displayName = 'FormHelperText';
export default FormHelperText;
